var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"teacher-tabbar"},[_c('van-tabs',{model:{value:(_vm.activeTabbar),callback:function ($$v) {_vm.activeTabbar=$$v},expression:"activeTabbar"}},[_vm._l((_vm.tabbarItems),function(item){return [(item.show)?_c('van-tab',{key:item.name,attrs:{"title":item.label,"name":item.name,"to":{
          name: item.name
        }}}):_vm._e()]})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }